import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import ReactList from 'react-list'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import shortid from 'shortid'
import moment from '../../lib/moment.js'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'
import { standard_cost_price_table } from './constants'

export default class StandardCostPriceTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'standardCostPrices')) !== JSON.stringify(prevState.standardCostPrices)) {
      let list
      switch (prevState.sort_column) {
        case 0: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'employee_level', 'desc')
          break
        }
        case 1: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'start_date', 'desc')
          break
        }
        case 2: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'end_date', 'desc')
          break
        }
        case 3: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'cost_number', 'desc')
          break
        }
        case 4: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'price_number', 'desc')
          break
        }
        case 5: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'wmd_number', 'desc')
          break
        }
        case 6: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'sga_price', 'desc')
          break
        }
        case 7: {
          list = orderBy(get(nextProps, 'standardCostPrices'), 'sga_support_price', 'desc')
          break
        }
        default: break
      }
      set(tempState, 'standardCostPrices', get(nextProps, 'standardCostPrices'))
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: false,
    sort_column: 0,
    standardCostPrices: [],
    items: [],
  }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state }
    const { standardCostPrices } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    switch (column) {
      case 0: {
        const newItems = orderBy(standardCostPrices, 'employee_level', sort_order)
        return this.setState({ items: newItems })
      }
      case 1: {
        const newItems = orderBy(standardCostPrices, 'start_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 2: {
        const newItems = orderBy(standardCostPrices, 'end_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 3: {
        const newItems = orderBy(standardCostPrices, 'cost_number', sort_order)
        return this.setState({ items: newItems })
      }
      case 4: {
        const newItems = orderBy(standardCostPrices, 'price_number', sort_order)
        return this.setState({ items: newItems })
      }
      case 5: {
        const newItems = orderBy(standardCostPrices, 'wmd_number', sort_order)
        return this.setState({ items: newItems })
      }
      case 6: {
        const newItems = orderBy(standardCostPrices, 'sga_price', sort_order)
        return this.setState({ items: newItems })
      }
      case 7: {
        const newItems = orderBy(standardCostPrices, 'sga_support_price', sort_order)
        return this.setState({ items: newItems })
      }
      default: return standardCostPrices
    }
  }

  renderItem = (index, key) => {
    const data = this.state.items[index]
    const rowID = get(this.props, 'rowID')
    return (
      <tr
        key={ shortid() }
        style={ {
          cursor: 'pointer',
          hover: '#E5E5E5',
          backgroundColor: key === rowID ? '#E5E5E5' : '',
        } }
        onClick={ () => this.props.clickRow(key, data) }
      >
        <td>{ data.employee_level }</td>
        <td>{ moment(data.start_date).format('DD/MM/YYYY') }</td>
        <td>{ moment(data.end_date).format('DD/MM/YYYY') }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.cost }
          />
        }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.price }
          />
        }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.wmd }
          />
        }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.sga_price }
          />
        }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.sga_support_price }
          />
        }</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state

    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <CustomTable bordered hover>
          <Header>
            <tr style={ { fontFamily: 'Gotham' } }>
              { standard_cost_price_table.map((h) =>
                (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                  { h.label }
                  { h.value === sort_column && (
                    sort_order && h.value === sort_column ?
                      <Icon src={ arrow_up } alt="logo" />
                      :
                      <Icon src={ arrow_down } alt="logo" />
                  )
                  }</HeadTable>)
              )}
            </tr>
          </Header>
          <BodyTable>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </CustomTable>
      </Wrapper>
    )
  }
}

StandardCostPriceTable.propTypes = {
  clickRow: PropTypes.func,
}
StandardCostPriceTable.defaultProps = {
  clickRow: () => {},
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const CustomTable = styled(Table)`
  background: white;
  thead {
    display:table;
    width: 100%;
    table-layout:fixed;
    font-family: 'Gotham-Bold' !important;
    font-size: 12px;
    background-color: #404040;
  } tbody tr {
    display:table;
    width: 100%;
    table-layout:fixed;
    font-family: 'Gotham' !important;
    font-weight: lighter !important;
    font-size: 14px;
    border: none;
  } thead th {
    border: 1px solid #dee2e6;
    font-size: 12px;
  } tbody td {
    border: 1px solid #dee2e6;
    font-size: 12px;
    word-wrap: break-word;
  }
  }
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px;
  cursor: pointer;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: black;
  color: white;
  font-family: 'Gotham-Bold' !important;
  font-weight: lighter !important;
`



// WEBPACK FOOTER //
// ./src/components/standard-cost-price/table.js